import {Palette} from "@mui/material";

export default {
  primary: {
    main: '#e10b17'
  },
  background: {
    paper: '#F9F9FB'
  },
  grey: {
    100: '#ededed',
    200: '#6f6f6f',
    // 300: 'rgba(0, 0, 0, 0.42)',
    400: '#f9f9fb',
    // 500: 'rgba(245, 245, 245, 0.1)',
    // 600: '#f5f5f5',
    // 700: 'rgba(255, 255, 255, 0.1)',
    // 800: 'rgba(255, 255, 255, 0.2)',
    // 900: '#6e6e6e',
    1000: '#edeff3',
  },
  black: {
    100: '#252525',
    80: 'rgba(0 0 0/80%)'
  },
  blue: {
    100: '#214FE2'
  },
  red: {
    100: '#e10b17',
    500: '#E10B0B'
  },
  // orange: {
  //   main: '#f07e01',
  //   secondary: '#f28536',
  // },
  // yellow: {
  //   main: '#e9d30c',
  // },
  // purple: {
  //   main: '#6401be',
  //   secondary: '#fb39ff',
  //   hover: '#8536f2',
  // },
  // brown: {
  //   100: '#7d3912',
  //   200: '#8c7e7e',
  // },
} as unknown as Palette;
